import React from 'react';
import { FileText, Download } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { documentatieData } from '../data/geoData';

const DocumentatiePage = () => (
  <main className="pt-28 min-h-screen">
    <SEO
      title="Documentatie & downloads – Staffing Force"
      description="Download alle documenten van Staffing Force Nederland: algemene voorwaarden, privacy statement (AVG), gedragscode, statuten, personeelshandboek, hybridebeleid en meer."
      keywords="documentatie, algemene voorwaarden, AVG, gedragscode, statuten, personeelshandboek, staffing force"
    />
    <PageHero
      label="Downloads"
      title={documentatieData.title}
      description={documentatieData.intro}
      image="https://images.unsplash.com/photo-1568667256549-094345857637?w=1920&q=85&auto=format&fit=crop"
    />
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="space-y-4">
          {documentatieData.docs.map((d, i) => (
            <FadeIn key={i} delay={i * 0.05}>
              <a
                href={d.url}
                download
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between p-4 md:p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-[#00897B]/40 hover:bg-[#00897B]/5 transition-colors group"
              >
                <div className="flex items-center gap-4 min-w-0">
                  <div className="w-12 h-12 rounded-lg bg-[#00897B]/10 flex items-center justify-center flex-shrink-0">
                    <FileText size={20} className="text-[#00897B]" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-semibold text-gray-900 text-sm md:text-base group-hover:text-[#00897B] transition-colors">
                      {d.name}
                    </h3>
                    <p className="text-gray-500 text-xs md:text-sm mt-0.5">{d.desc}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0 ml-3">
                  <span className="text-xs text-gray-500 bg-gray-200 px-2 py-0.5 rounded">{d.type}</span>
                  <Download
                    size={18}
                    className="text-gray-400 group-hover:text-[#00897B] transition-colors"
                  />
                </div>
              </a>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.3}>
          <div className="mt-10 p-5 bg-gray-50 border border-gray-100 rounded-xl text-sm text-gray-600">
            <strong className="text-gray-800">Document niet gevonden of vraag over een document?</strong> Neem
            contact op via{' '}
            <a href="tel:+31205811000" className="text-[#00897B] font-semibold hover:underline">
              (020) 58 11 000
            </a>{' '}
            of{' '}
            <a
              href="mailto:info@staffingforce.nl"
              className="text-[#00897B] font-semibold hover:underline"
            >
              info@staffingforce.nl
            </a>
            .
          </div>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default DocumentatiePage;
